import {
  EGamePeriod,
  EIncidentsKind,
  EIncidentsTeamGround,
  EStatusMatches,
} from '@/app/pages/sports/football/enums';
import {
  EStatKind,
  EStatMeasure,
} from '@/app/pages/sports/football/match-details/models';
import { isValid } from 'date-fns';

export const handleGamePeriord = (gamePeriod: number) => {
  switch (gamePeriod) {
    case 0:
      return null;
    case 1:
      return EGamePeriod.FIRST_HALF;
    case 2:
      return EGamePeriod.HALF_TIME;
    case 3:
      return EGamePeriod.SECOND_HALF;
    case 4:
      return EGamePeriod.OVERTIME;
    case 5:
      return EGamePeriod.PENALTY_SHOOT_OUT;

    default:
      return null;
  }
};

export const handleMatchKind = (kind: number) => {
  switch (kind) {
    case 0:
      return EStatusMatches.TO_BE_DEFINED;
    case 1:
      return EStatusMatches.UPCOMING;
    case 2:
      return EStatusMatches.NORMAL;
    case 3:
      return EStatusMatches.ENDED;
    case 4:
      return EStatusMatches.CANCELED;
    case 5:
      return EStatusMatches.INTERRUPTED;
    case 6:
      return EStatusMatches.DELAYED;
    case 7:
      return EStatusMatches.TO_BE_DEFINED;
    // case 8:
    //   return EStatusMatches.HIDDEN;

    default:
      return EStatusMatches.TO_BE_DEFINED;
  }
};

export const handleIncidentsKind = (kind: number) => {
  switch (kind) {
    case 0:
      return EIncidentsKind.KIND_UNSPECIFIED;
    case 1:
      return EIncidentsKind.GOAL;
    case 2:
      return EIncidentsKind.CORNER;
    case 3:
      return EIncidentsKind.OWN_GOAL;
    case 4:
      return EIncidentsKind.YELLOW_CARD;
    case 5:
      return EIncidentsKind.RED_CARD;
    case 6:
      return EIncidentsKind.CARD_UPGRADE;
    case 7:
      return EIncidentsKind.SUBSTITUTION;
    case 8:
      return EIncidentsKind.PENALTY;
    case 9:
      return EIncidentsKind.VAR;
    case 10:
      return EIncidentsKind.START;
    case 11:
      return EIncidentsKind.MIDFIELD;
    case 12:
      return EIncidentsKind.END;
    case 13:
      return EIncidentsKind.PENALTY_MISSED;
    case 14:
      return EIncidentsKind.OVERTIME_IS_OVER;
    case 15:
      return EIncidentsKind.PENALTY_KICK_ENDED;
    case 16:
      return EIncidentsKind.EXTRA_TIME;

    default:
      return EIncidentsKind.KIND_UNSPECIFIED;
  }
};

export const handleIncidensTeamGround = (teamGround: number) => {
  switch (teamGround) {
    case 0:
      return EIncidentsTeamGround.NEUTRAL;
    case 1:
      return EIncidentsTeamGround.HOME;
    case 2:
      return EIncidentsTeamGround.AWAY;
    default:
      return EIncidentsTeamGround.NEUTRAL;
  }
};

export const handleMatchStartTime = (startTime: number) => {
  const isValidDate = isValid(new Date(startTime * 1000));
  if (!isValidDate) {
    return null;
  }

  return new Date(startTime * 1000);
};

export const handleStatKind = (kind: number) => {
  switch (kind) {
    case 0:
      return null;
    case 1:
      return EStatKind.ATTACK;
    case 2:
      return EStatKind.DANGEROUS_ATTACK;
    case 3:
      return EStatKind.CORNER;
    case 4:
      return EStatKind.POSSESSION;
    case 5:
      return EStatKind.YELLOW_CARD;
    case 6:
      return EStatKind.RED_CARD;
    case 7:
      return EStatKind.ON_TARGET;
    case 8:
      return EStatKind.OFF_TARGET;
    case 9:
      return EStatKind.PENALTY;
    default:
      return null;
  }
};

export const handleStatMeasure = (measure: number) => {
  switch (measure) {
    case 0:
      return null;
    case 1:
      return EStatMeasure.PERCENTAGE;
    case 2:
      return EStatMeasure.QUANTITY;
    default:
      return null;
  }
};
